import React from "react";
import {
  IconAccessible,
  IconChevronRight,
  IconRss,
  IconMail,
  IconFileText,
  IconQuestionMark,
  IconTipJar,
  IconMapPin,
  IconLifebuoy,
  IconHeart,
  IconCode,
  IconFileTypeDoc,
  IconDiscount,
  IconLicense,
} from "@tabler/icons-react";

export const data = [
  { label: "Wall of Love", description: "Hear what others are saying!", href: "/testimonials", icon: IconHeart },

  {
    icon: IconCode,
    label: "a11yStart",
    description: "Make your accessible saas here !",
    href: "#parent",
    rightSection: <IconChevronRight size={16} stroke={1.5} />,
    children: [
      {
        label: "Documentation",
        description:
          "Overview of the documentation. Learn how to build accessible, production-ready apps step by step — from setup to deployment.",
        href: "/a11ystart",
        icon: IconFileTypeDoc,
      },
      {
        label: "Discounts",
        description:
          "Exclusive perks for a11yStart makers — enjoy curated deals from trusted dev tools & SaaS partners",
        href: "/a11ystart/discounts",
        icon: IconDiscount,
      },

      {
        label: "Licence",
        description: "License Agreement.",
        href: "/a11ystart/licence-agreement",
        icon: IconLicense,
      },
    ],
  },

  {
    icon: IconLifebuoy,
    label: "Help",
    description: "Answers, support, and friendly assistance await!",
    href: "#parent",
    rightSection: <IconChevronRight size={16} stroke={1.5} />,
    children: [
      { label: "FAQ", description: "Quick answers to common questions.", href: "/faq", icon: IconQuestionMark },
      {
        icon: IconRss,
        label: "Explore",
        href: "/discovery-feed",
        description: "Dive into new content!",
      },
      { label: "Support", description: "We're here to help!", href: "/support", icon: IconMail },
      { label: "Glossary", description: "Techy terms made easy.", href: "/glossary", icon: IconFileText },
      { label: "Atlas", description: "See the full layout of the app.", href: "/atlas", icon: IconMapPin },

      {
        label: "Tip Jar",
        description: "Tip the project and spread the love.",
        href: "/tip-jar",
        icon: IconTipJar,
      },
    ],
  },

  {
    icon: IconAccessible,
    label: "Accessibility",
    description: "A11Y - Everyone deserves a great experience.",
    href: "/accessibility",
  },
];
